// v6 F12e — 10 professionele schildersiconen als standaard-avatars.
// Gebruikt voor bedrijven zonder eigen logo. Elke avatar wordt gerenderd als
// SVG in de EmmaMeasure kleurpalet (#D96C4A, #7F4124, #6B8E6B, #B07A4F, #8A9A86).
// Data-URL geëncodeerd zodat opslag identiek verloopt als geuploade logo's
// (logo_data_url veld — geen backend schema-wijziging nodig).

import React from "react";
import { Check } from "lucide-react";

// SVG-generator: geeft data-URL terug (base64) voor gebruik in company.logo_data_url.
// Kleuren komen uit de EmmaMeasure design tokens.
const svg = (inner) => {
  const wrapper = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
    <rect width="100" height="100" rx="18" fill="#FDF7F2"/>
    ${inner}
  </svg>`;
  return `data:image/svg+xml;base64,${btoa(wrapper)}`;
};

export const DEFAULT_AVATARS = [
  {
    id: "brush",
    name: "Verfkwast",
    dataUrl: svg(`
      <rect x="40" y="18" width="20" height="34" rx="3" fill="#B07A4F"/>
      <rect x="38" y="50" width="24" height="8" fill="#7F4124"/>
      <path d="M35 58 L65 58 L60 82 L40 82 Z" fill="#D96C4A"/>
      <path d="M42 82 L45 92 M50 82 L50 92 M58 82 L55 92" stroke="#7F4124" stroke-width="1.5" stroke-linecap="round"/>
    `),
  },
  {
    id: "roller",
    name: "Verfrol",
    dataUrl: svg(`
      <rect x="20" y="45" width="60" height="14" rx="7" fill="#6B8E6B"/>
      <rect x="46" y="18" width="8" height="30" rx="2" fill="#7F4124"/>
      <rect x="30" y="59" width="40" height="6" fill="#D96C4A" opacity="0.4"/>
      <rect x="35" y="65" width="30" height="4" fill="#D96C4A" opacity="0.25"/>
    `),
  },
  {
    id: "paint-can",
    name: "Verfpot",
    dataUrl: svg(`
      <rect x="28" y="30" width="44" height="52" rx="4" fill="#D96C4A"/>
      <rect x="26" y="26" width="48" height="8" rx="2" fill="#7F4124"/>
      <path d="M28 34 Q28 30 32 30 L68 30 Q72 30 72 34" stroke="#7F4124" stroke-width="2" fill="none"/>
      <ellipse cx="50" cy="82" rx="22" ry="4" fill="#7F4124" opacity="0.3"/>
      <rect x="34" y="46" width="32" height="4" fill="#FDF7F2" opacity="0.4"/>
      <text x="50" y="66" text-anchor="middle" font-family="Georgia" font-size="14" fill="#FDF7F2" font-weight="bold">P</text>
    `),
  },
  {
    id: "putty-knife",
    name: "Plamuurmes",
    dataUrl: svg(`
      <rect x="30" y="24" width="40" height="10" rx="2" fill="#8A9A86"/>
      <rect x="42" y="34" width="16" height="24" fill="#7F4124"/>
      <path d="M28 58 L72 58 L72 78 L28 78 Z" fill="#B07A4F"/>
      <line x1="28" y1="63" x2="72" y2="63" stroke="#7F4124" stroke-width="1"/>
    `),
  },
  {
    id: "ladder",
    name: "Ladder",
    dataUrl: svg(`
      <line x1="30" y1="18" x2="30" y2="86" stroke="#B07A4F" stroke-width="4" stroke-linecap="round"/>
      <line x1="70" y1="18" x2="70" y2="86" stroke="#B07A4F" stroke-width="4" stroke-linecap="round"/>
      <line x1="30" y1="30" x2="70" y2="30" stroke="#7F4124" stroke-width="3.5" stroke-linecap="round"/>
      <line x1="30" y1="46" x2="70" y2="46" stroke="#7F4124" stroke-width="3.5" stroke-linecap="round"/>
      <line x1="30" y1="62" x2="70" y2="62" stroke="#7F4124" stroke-width="3.5" stroke-linecap="round"/>
      <line x1="30" y1="78" x2="70" y2="78" stroke="#7F4124" stroke-width="3.5" stroke-linecap="round"/>
    `),
  },
  {
    id: "bucket",
    name: "Verfemmer",
    dataUrl: svg(`
      <path d="M28 34 L72 34 L68 82 L32 82 Z" fill="#8A9A86"/>
      <ellipse cx="50" cy="34" rx="22" ry="4" fill="#6B8E6B"/>
      <path d="M28 34 Q28 18 50 18 Q72 18 72 34" stroke="#7F4124" stroke-width="2.5" fill="none"/>
      <ellipse cx="50" cy="82" rx="18" ry="3" fill="#7F4124" opacity="0.3"/>
    `),
  },
  {
    id: "drop",
    name: "Verfdruppel",
    dataUrl: svg(`
      <path d="M50 18 Q30 52 30 66 A20 20 0 1 0 70 66 Q70 52 50 18 Z" fill="#D96C4A"/>
      <ellipse cx="42" cy="60" rx="6" ry="10" fill="#FDF7F2" opacity="0.4" transform="rotate(-20 42 60)"/>
    `),
  },
  {
    id: "wall-roller",
    name: "Muur met roller",
    dataUrl: svg(`
      <rect x="18" y="30" width="64" height="46" fill="#F0EFEA"/>
      <rect x="18" y="30" width="42" height="14" fill="#6B8E6B" opacity="0.9"/>
      <rect x="24" y="44" width="30" height="8" fill="#6B8E6B" opacity="0.7"/>
      <rect x="52" y="22" width="32" height="10" rx="5" fill="#B07A4F"/>
      <rect x="66" y="12" width="4" height="18" fill="#7F4124"/>
    `),
  },
  {
    id: "sanding-block",
    name: "Schuurblok",
    dataUrl: svg(`
      <rect x="24" y="40" width="52" height="26" rx="4" fill="#B07A4F"/>
      <rect x="26" y="42" width="48" height="4" fill="#7F4124" opacity="0.5"/>
      <rect x="26" y="60" width="48" height="4" fill="#7F4124" opacity="0.5"/>
      <line x1="30" y1="52" x2="34" y2="52" stroke="#FDF7F2" stroke-width="1.5"/>
      <line x1="42" y1="52" x2="46" y2="52" stroke="#FDF7F2" stroke-width="1.5"/>
      <line x1="54" y1="52" x2="58" y2="52" stroke="#FDF7F2" stroke-width="1.5"/>
      <line x1="66" y1="52" x2="70" y2="52" stroke="#FDF7F2" stroke-width="1.5"/>
    `),
  },
  {
    id: "painter-cap",
    name: "Schilderspet",
    dataUrl: svg(`
      <ellipse cx="50" cy="62" rx="30" ry="5" fill="#7F4124"/>
      <path d="M22 62 Q22 34 50 30 Q78 34 78 62 Z" fill="#D96C4A"/>
      <ellipse cx="50" cy="60" rx="26" ry="6" fill="#D96C4A"/>
      <path d="M20 62 L80 62 L82 68 L18 68 Z" fill="#B07A4F"/>
      <circle cx="50" cy="45" r="4" fill="#FDF7F2"/>
      <text x="50" y="49" text-anchor="middle" font-family="Georgia" font-size="8" fill="#D96C4A" font-weight="bold">E</text>
    `),
  },
];

/**
 * AvatarPicker — grid van 10 EmmaMeasure schildersiconen + initialen fallback.
 * Klik zet `logo_data_url` op de gekozen SVG (data-URL). Ook een "Geen avatar"
 * knop die de initialen fallback activeert (leeg logo_data_url).
 */
export default function AvatarPicker({ currentDataUrl, initials = "", onSelect, onClear }) {
  return (
    <div className="space-y-3" data-testid="avatar-picker">
      <div className="text-xs uppercase tracking-[0.15em] font-bold text-[#5D7259] flex items-center gap-2">
        Kies een standaard-avatar
      </div>
      <div className="grid grid-cols-5 gap-3">
        {DEFAULT_AVATARS.map((a) => {
          const selected = currentDataUrl === a.dataUrl;
          return (
            <button
              type="button"
              key={a.id}
              onClick={() => onSelect(a.dataUrl)}
              className={`relative w-full aspect-square rounded-xl border-2 overflow-hidden transition hover:scale-105 ${selected ? "border-[#D96C4A] ring-2 ring-[#D96C4A]/30" : "border-[#E5E2DC] hover:border-[#D96C4A]/50"}`}
              title={a.name}
              data-testid={`avatar-${a.id}`}
            >
              <img src={a.dataUrl} alt={a.name} className="w-full h-full object-contain" />
              {selected && (
                <div className="absolute top-1 right-1 w-5 h-5 bg-[#D96C4A] rounded-full flex items-center justify-center">
                  <Check className="w-3 h-3 text-white" />
                </div>
              )}
            </button>
          );
        })}
      </div>
      <div className="text-[11px] text-[#4F4F4D] flex items-center justify-between gap-2 pt-1">
        <span>Geen eigen logo? Kies een avatar of laat de initialen &quot;{initials || "??"}&quot; zichtbaar.</span>
        <button
          type="button"
          onClick={onClear}
          className="text-[#D96C4A] hover:underline text-xs font-medium whitespace-nowrap"
          data-testid="avatar-clear-btn"
        >
          Alleen initialen
        </button>
      </div>
    </div>
  );
}

/**
 * InitialsFallback — kleine cirkel met eerste 2 letters van bedrijfsnaam,
 * gebruikt wanneer er geen logo_data_url is.
 */
export function InitialsFallback({ name = "", className = "w-full h-full" }) {
  const initials = (name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join("") || "?";
  return (
    <div className={`${className} rounded-2xl bg-gradient-to-br from-[#D96C4A] to-[#B07A4F] text-white font-heading font-bold flex items-center justify-center`}
      style={{ fontSize: "2rem" }}
      data-testid="logo-initials-fallback"
    >
      {initials}
    </div>
  );
}
